import AdminNavBar from "./AdminNavBar"
import UserNavBar from "./UserNavBar"

const UserAdmin = () => {
	return (
		<div>
			<AdminNavBar />
			<UserNavBar />
		</div>
	)
}

export default UserAdmin;
